export default __webpack_public_path__ + "static/media/aihome3.70d406a4.webp";